<template>
    <div>
        <form class="form-horizontal" >

            <div class="panel panel-info">
                <!-- Default panel contents -->
                <div class="panel-heading">
                    <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS BÁSICOS
                </div>
                <div class="panel-body">
                    <div class="form-group">
                        <div class="col-sm-3">
                            <label for="rack" :class="{'text-danger': !porta.rack}" class="control-label">RACK</label>
                            <input id="rack" type="number" v-model.number="porta.rack" class="form-control" >
                        </div>
                        <div class="col-sm-3">
                            <label for="shelf" :class="{'text-danger': !porta.shelf}" class="control-label">PRATELEIRA</label>
                            <input id="shelf" type="number" v-model.number="porta.shelf" class="form-control" >
                        </div>
                        <div class="col-sm-3">
                            <label for="slot" :class="{'text-danger': !porta.slot}" class="control-label">SLOT</label>
                            <input id="slot" type="number" v-model.number="porta.slot" class="form-control" >
                        </div>
                        <div class="col-sm-3">
                            <label for="numero" :class="{'text-danger': !porta.numero}" class="control-label">NÚMERO DA PORTA</label>
                            <input id="numero" type="number" v-model.number="porta.numero" class="form-control right" >
                        </div>
                    </div>
                    <div class="form-group">



                        <div class="col-sm-3">
                            <label for="nome" class="control-label">NOME DA PORTA</label>
                            <input id="nome" disabled type="text" :value="(porta.numero) ? 'PON-' + porta.numero : null" class="form-control" >
                        </div>

                        <div class="col-sm-6" v-if="fibra">
                            <label for="fibra" class="control-label">FIBRA</label>
                            <input id="fibra" disabled type="text" :value="fibra.nome" class="form-control" >
                        </div>

                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-10">
                    <button type="button" v-if="user.level < 5" :disabled="! porta.numero || ! porta.rack || ! porta.slot || ! porta.shelf"
                            @click="save()"
                            class="btn btn-success">
                        <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR PONTO
                    </button>
                </div>
            </div>

            <list-c-t-o-by-porta-p-o-n v-if="porta && porta._id" :_id="porta._id"/>

        </form>
    </div>
</template>
<script>
import { PortaPon, Fibra } from "../../../class/index";
import { ListCTOByPortaPON } from "../../../components/exports";

export default {
    components: {
        ListCTOByPortaPON
    },
    data() {
        return {
            user: null,
            porta: PortaPon.create(),
            fibra: null
        };
    },
    computed: {
        _id() {
            return this.$route.params.id;
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this._id) {
            this.loadPonto(this.$route.params.id);
        }
    },
    beforeDestroy() {
        console.log("ponto off");
    },
    methods: {
        async loadPonto() {
            this.porta = await PortaPon.byID(this._id);
            this.fibra = await Fibra.byPortaPon(this._id);
        },
        save() {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o ponto?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            PortaPon.save(this.porta)
                                .then(() => {
                                    resolve();
                                    this.$router.push({ path: "/portas-pon" });
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
